<div class="p-0">
  <div *ngFor="let rebate of rebates; let i = index" class="form-check" [class.disabled]="rebate.disabled">
    <input
      class="form-check-input check"
      type="checkbox"
      [checked]="checkBoxColor(rebate)"
      (click)="onToggleAccept(rebate)"
      [disabled]="rebate.disabled"/>
    <ng-container *ngIf="rebate.type!=='customRebate'">
      <div class="pl-2 pt-1 cursor-default color-grey-4" [class.disabled]="rebate.disabled">
        {{ rebate.title }}
        <span class="float-right cursor-default">
          {{ rebate.value | currency: "USD":"symbol":"1.0-0" }}
        </span>
      </div>
    </ng-container>
    <ng-container *ngIf="rebate.type==='customRebate'">
      <div class="pl-2 pt-1 cursor-default color-grey-4">
         <span
           class="cursor-default app-text-blue hover-link-dotted"
           (click)="overrideCustomRebateName()">
          {{ customRebateName || rebate.title }}
         </span>
        <span
          class="float-right cursor-default app-text-blue hover-link-dotted"
          (click)="overrideCustomRebateAmount(rebate)">
          {{ (rebate?.value | currency: "USD":"symbol":"1.0-0") || "$0" }}
      </span>
      </div>
    </ng-container>
  </div>
  <div *ngIf="rebates.length === 0" class="d-flex align-items-center p-2">
    <span class="app-text-danger cursor-default">No Rebates</span>
  </div>
</div>
